var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "63EEE512-9969-4337-A9E9-8E9A5798912F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 1660,
    height: 1010
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 1100,
    height: 990
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 1100,
    height: 260
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8288777,8.11857422 L21.718042,0.176835937 C21.6025718,0.0638671875 21.4432639,0 21.2768674,0 L9.18824695,0 C7.83537356,0 6.73470657,1.03675781 6.73470657,2.31105469 L6.73470657,10.3846289 L1.83564716,10.3846289 C0.823463817,10.3846289 0,11.1603516 0,12.1139062 L0,20.7707812 C0,21.7242773 0.823463817,22.5 1.83564716,22.5 L6.73470657,22.5 L6.73470657,27.6929883 C6.73470657,28.9650586 7.83537356,30 9.18824695,30 L27.5464596,30 C28.899333,30 30,28.9656445 30,27.6942773 L30,8.51865234 C30,8.36947266 29.9386273,8.22609375 29.8288777,8.11857422 Z M21.4285892,1.55748047 L28.0868752,8.07691406 L21.4285892,8.07691406 L21.4285892,1.55748047 Z M20.2040575,1.15382813 L20.2040575,8.65382813 C20.2040575,8.97246094 20.4782138,9.23074219 20.8162923,9.23074219 L28.7754683,9.23074219 L28.7754683,27.6942773 C28.7754683,28.3294336 28.2241088,28.8461719 27.5463974,28.8461719 L9.18824695,28.8461719 C8.51053554,28.8461719 7.95917606,28.3289063 7.95917606,27.6930469 L7.95917606,22.5 L18.3684725,22.5 C19.3806559,22.5 20.2041197,21.7242773 20.2041197,20.7707813 L20.2041197,12.1139063 C20.2041197,11.1603516 19.3806559,10.3846289 18.3684725,10.3846289 L7.95917606,10.3846289 L7.95917606,2.31105469 C7.95917606,1.67291016 8.51053554,1.15382813 9.18824695,1.15382813 L20.2040575,1.15382813 Z M4.86335439,13.59375 C5.5267094,13.59375 6.00026407,13.7084026 6.2840326,13.9377111 C6.56780113,14.1670197 6.70968327,14.5502507 6.70968327,15.0874155 C6.70968327,15.6955267 6.51989287,16.1687061 6.1403064,16.5069679 C5.76071992,16.8452297 5.22942967,17.0143581 4.5464197,17.0143581 L4.07470294,17.0143581 L4.07470294,19.21875 L2.96174621,19.21875 L2.96174621,13.59375 L4.86335439,13.59375 Z M9.93799483,13.59375 C10.7831582,13.59375 11.4305339,13.8249555 11.8801412,14.2873733 C12.3297485,14.7497912 12.5545487,15.4168031 12.5545487,16.2884291 C12.5545487,17.2157986 12.3162359,17.9360194 11.839603,18.4491132 C11.3629702,18.962207 10.6959398,19.21875 9.83849208,19.21875 L7.5904669,19.21875 L7.5904669,13.59375 L9.93799483,13.59375 Z M17.0063756,13.59375 L17.0063756,14.3652872 L14.7104417,14.3652872 L14.7104417,16.0755912 L16.5973088,16.0755912 L16.5973088,16.8509291 L14.7104417,16.8509291 L14.7104417,19.21875 L13.5753733,19.21875 L13.5753733,13.59375 L17.0063756,13.59375 Z M9.41099877,14.3652872 L8.72553535,14.3652872 L8.72553535,18.4206081 L9.5731514,18.4206081 C10.1701709,18.4206081 10.615472,18.2502129 10.909068,17.9094172 C11.202664,17.5686216 11.3494598,17.0511014 11.3494598,16.3568412 C11.3494598,15.8196764 11.2315318,15.372468 10.9956723,15.0152027 C10.8335188,14.7694244 10.6382005,14.5996626 10.4097116,14.5059122 C10.1812226,14.4121617 9.8483217,14.3652872 9.41099877,14.3652872 Z M4.5169374,14.3652872 L4.07470294,14.3652872 L4.07470294,16.2428209 L4.29582017,16.2428209 C4.68400569,16.2428209 4.99049568,16.1497053 5.21529932,15.9634713 C5.44010296,15.7772372 5.55250309,15.5244948 5.55250309,15.2052365 C5.55250309,14.6452675 5.20731798,14.3652872 4.5169374,14.3652872 Z",
    id: "path-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Furniture-/-3.1_Factory_Profile_01",
    transform: "translate(-270.000000, -1365.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wrapper",
    fill: "#F6F7FA"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u25A0-Shape",
    x: 0,
    y: 0,
    width: 1920,
    height: 1660
  })), /*#__PURE__*/React.createElement("g", {
    id: "Conteainer",
    transform: "translate(220.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shadow",
    x: 0,
    y: 0,
    width: 1700,
    height: 1380
  }), /*#__PURE__*/React.createElement("g", {
    id: "Backgorund",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u25A0-Shape",
    x: 0,
    y: 0,
    width: 1700,
    height: 1380
  })), /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(20.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 500.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bound"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Block_Left",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bound"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 640.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Bound",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    mask: "url(#mask-6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bound",
    x: 0,
    y: 0,
    width: 520,
    height: 60
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_pdf",
    transform: "translate(10.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic_file_pdf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color",
    mask: "url(#mask-8)",
    fill: "#CC0328"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u25A0-Color",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }))))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.3f8eb900fe10d4e3209514435a59ec7a.svg";
export { ForwardRef as ReactComponent };